﻿import { Ignore } from '../decorators/inject-decorator';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IKbColor } from '../kb3d-models';
import { Token } from '../token';

export interface IKbColorLike {
    r: number;
    g: number;
    b: number;
    a?: number;
}

@Kb3dModel<KbColor>({
    token: Token.KbColor,
    trackChanges: false,
    create: args => new KbColor(args.r || 0, args.g || 0, args.b || 0, args.a),
})
export class KbColor implements IKbColor {
    constructor(
        @Ignore() readonly r: number,
        @Ignore() readonly g: number,
        @Ignore() readonly b: number,
        @Ignore() readonly a: number = 1
    ) {}

    clone() {
        return new KbColor(this.r, this.g, this.b, this.a);
    }
    assign(c: { r?: number | null; g?: number | null; b?: number | null; a?: number | null }) {
        return new KbColor(
            typeof c.r === 'number' ? c.r : this.r,
            typeof c.g === 'number' ? c.g : this.g,
            typeof c.b === 'number' ? c.b : this.b,
            typeof c.a === 'number' ? c.a : this.a
        );
    }
    equal(c?: KbColor): boolean {
        return !!c && c.r == this.r && c.g == this.g && c.b == this.b && c.a == this.a;
    }
    cssString() {
        if (this.a < 1) {
            return `rgba(${this.r * 255}, ${this.g * 255}, ${this.b * 255}, ${this.a})`;
        } else {
            return `rgb(${this.r * 255}, ${this.g * 255}, ${this.b * 255})`;
        }
    }
    toObject() {
        return { r: this.r, g: this.g, b: this.b, a: this.a } as IKbColorLike;
    }
    toIntObject() {
        return { r: this.r * 255, g: this.g * 255, b: this.b * 255, a: this.a };
    }
    static From(c: IKbColorLike) {
        return new KbColor(c.r, c.g, c.b, c.a);
    }
    static FromIntObject(c: IKbColorLike) {
        return new KbColor(c.r / 255, c.g / 255, c.b / 255, c.a != null ? c.a : 1);
    }
    static White() {
        return new KbColor(1, 1, 1, 1);
    }
    static Black() {
        return new KbColor(0, 0, 0, 1);
    }
    static Transparent() {
        return new KbColor(0, 0, 0, 0);
    }
    static Green() {
        return new KbColor(0, 1, 0);
    }
    static Red() {
        return new KbColor(1, 0, 0);
    }
    static KbmaxOrange() {
        return new KbColor(227 / 255, 131 / 255, 28 / 255);
    }
    static KbmaxBlue() {
        return new KbColor(8 / 255, 72 / 255, 96 / 255);
    }
}
